import { render, staticRenderFns } from "./RegistInputHeaderForm.vue?vue&type=template&id=7a2abaad&"
import script from "./RegistInputHeaderForm.vue?vue&type=script&lang=ts&"
export * from "./RegistInputHeaderForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegistInputHeaderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports